<template>
  <div class="questionroot">
    <div
      v-for="(range, idx) in question.steamjs"
      :key="range.index.toString() + idx"
      :id="question.id + '_stem_' + idx"
      class="stemrange"
    >
      <span class="question-number" v-if="idx === 0">
        {{ question.index }}.
        <span
          class="earned-score"
          v-if="typeof question.earnedScore === 'number'"
          >({{ question.earnedScore }}分)</span
        >
      </span>
      <template v-for="(segment, n) in buildRangeSegments(range.wordInfos, '')">
        <span
          v-if="segment.type === 'text'"
          :key="'stem-text-' + question.id + '-' + idx + '-' + n"
          class="stem-content"
          >{{ segment.content }}</span
        >
        <span
          v-else-if="segment.type === 'math'"
          :key="'stem-math-' + question.id + '-' + idx + '-' + n"
          class="formula_tex"
          v-katex="katexOptions"
          >{{ segment.content }}</span
        >
        <img
          v-else
          :key="'stem-img-' + question.id + '-' + idx + '-' + n"
          :src="segment.src"
        />
      </template>
    </div>
    <div
      v-for="(ops, i) in question.optionsjs"
      :key="'ops-' + ops.index + '-' + i"
      class="optionroot"
    >
      <div
        v-for="(range, idx) in ops.ranginfos"
        :key="ops.index + '-' + range.index + '-' + idx"
        :id="question.id + '_option_' + i + '_' + idx"
        class="optionrange"
      >
        <template
          v-for="(segment, n) in buildRangeSegments(
            range.wordInfos,
            idx === 0 ? `${charcodes[i]}.` : ''
          )"
        >
          <span
            v-if="segment.type === 'text'"
            :key="'option-text-' + question.id + '-' + i + '-' + idx + '-' + n"
            class="tex2jax_ignore"
            >{{ segment.content }}</span
          >
          <span
            v-else-if="segment.type === 'math'"
            :key="'option-math-' + question.id + '-' + i + '-' + idx + '-' + n"
            class="formula_tex"
            v-katex="katexOptions"
            >{{ segment.content }}</span
          >
          <img
            v-else
            :key="'option-img-' + question.id + '-' + i + '-' + idx + '-' + n"
            :src="segment.src"
          />
        </template>
      </div>
    </div>
    <div
      v-for="(range, idx) in question.answerjs"
      :key="range.index + '-answer-' + idx"
      :id="question.id + '_answer_' + idx"
      class="answerrange"
    >
      <span v-if="idx === 0" class="tex2jax_hit">【答案】</span>
      <template v-for="(segment, n) in buildRangeSegments(range.wordInfos)">
        <span
          v-if="segment.type === 'text'"
          :key="'answer-text-' + question.id + '-' + idx + '-' + n"
          class="tex2jax_ignore"
          >{{ segment.content }}</span
        >
        <span
          v-else-if="segment.type === 'math'"
          :key="'answer-math-' + question.id + '-' + idx + '-' + n"
          class="formula_tex"
          v-katex="katexOptions"
          >{{ segment.content }}</span
        >
        <img
          v-else
          :key="'answer-img-' + question.id + '-' + idx + '-' + n"
          :src="segment.src"
        />
      </template>
    </div>
    <div
      v-for="(range, idx) in question.solvejs"
      :key="range.index + '-solve-' + idx"
      :id="question.id + '_slove_' + idx"
      class="solverange"
    >
      <span v-if="idx === 0" class="tex2jax_hit">【解析】</span>
      <template v-for="(segment, n) in buildRangeSegments(range.wordInfos)">
        <span
          v-if="segment.type === 'text'"
          :key="'solve-text-' + question.id + '-' + idx + '-' + n"
          class="tex2jax_ignore"
          >{{ segment.content }}</span
        >
        <span
          v-else-if="segment.type === 'math'"
          :key="'solve-math-' + question.id + '-' + idx + '-' + n"
          class="formula_tex"
          v-katex="katexOptions"
          >{{ segment.content }}</span
        >
        <img
          v-else
          :key="'solve-img-' + question.id + '-' + idx + '-' + n"
          :src="segment.src"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "questionItem",
  data: () => ({
    charcodes: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    katexOptions: {
      delimiters: [
        { left: "$$", right: "$$", display: true },
        { left: "$", right: "$", display: false },
        { left: "\\(", right: "\\)", display: false },
        { left: "\\[", right: "\\]", display: true }
      ],
      throwOnError: false,
      strict: "ignore"
    }
  }),
  props: {
    question: {}
  },
  methods: {
    formatFormula(latex) {
      return `$${latex || ""}$`;
    },
    splitTextAndMath(content) {
      const segments = [];
      if (!content) {
        return segments;
      }
      let buffer = "";
      let inMath = false;
      for (let i = 0; i < content.length; i++) {
        const current = content[i];
        const previous = i > 0 ? content[i - 1] : "";
        const isMathDelimiter = current === "$" && previous !== "\\";
        if (!isMathDelimiter) {
          buffer += current;
          continue;
        }
        if (inMath) {
          segments.push({ type: "math", content: `$${buffer}$` });
          buffer = "";
          inMath = false;
          continue;
        }
        if (buffer) {
          segments.push({
            type: "text",
            content: buffer.replace(/\\\$/g, "$")
          });
        }
        buffer = "";
        inMath = true;
      }
      if (buffer) {
        if (inMath) {
          segments.push({
            type: "math",
            content: `$${buffer}$`
          });
        } else {
          segments.push({
            type: "text",
            content: buffer.replace(/\\\$/g, "$")
          });
        }
      }
      return segments;
    },
    flushTextBuffer(segments, textBuffer) {
      if (!textBuffer) {
        return "";
      }
      this.splitTextAndMath(textBuffer).forEach(item => segments.push(item));
      return "";
    },
    buildRangeSegments(wordInfos, prefix = "") {
      const segments = [];
      let textBuffer = prefix || "";
      (wordInfos || []).forEach(item => {
        if (item.wdType === 2) {
          textBuffer = this.flushTextBuffer(segments, textBuffer);
          segments.push({ type: "img", src: item.imgSrc || item.buffer || "" });
          return;
        }
        if (item.wdType === 1) {
          textBuffer = this.flushTextBuffer(segments, textBuffer);
          segments.push({
            type: "math",
            content: this.formatFormula(item.latex)
          });
          return;
        }
        textBuffer += item.content || "";
      });
      this.flushTextBuffer(segments, textBuffer);
      return segments;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.questionroot {
  padding: 0px;
  margin: 30px 0px;
  font-size: 18px;
  font-family: "SimSun", "Songti SC", serif;
  line-height: 1.8; // Increased line height for better readability
  color: #333333; // Softer black
  letter-spacing: 0.5px; // Slightly better spacing
}
.optionroot {
  margin: 0px;
  padding: 0px;
}
.optionrange {
  padding-left: 20px;
  text-align: left;
  margin: 8px 0px;
  page-break-inside: avoid !important;
  font-size: 18px;
  display: block; // Use standard block flow
}
.stemrange {
  padding-left: 0;
  text-align: left;
  margin: 12px 0px;
  page-break-inside: avoid !important;
  color: #000;
  display: block; // Use standard block flow
}
.question-number {
  font-weight: 700;
  margin-right: 4px;
  font-family: "SimHei", sans-serif;
  font-size: 18px;

  .earned-score {
    color: #ff4d4f; // Red color for score
    font-size: 16px;
    margin-left: 5px;
    font-weight: 700;
  }
}
.stem-content {
  font-family: "SimSun", "Songti SC", serif;
  font-size: 18px;
  vertical-align: middle; // Align text with formulas
}

.answerrange,
.solverange {
  padding-left: 0;
  text-align: left;
  margin: 12px 0px;
  page-break-inside: avoid !important;
  display: block; // Use standard block flow
}

.tex2jax_ignore {
  font-size: 18px;
  font-family: "SimSun", "Songti SC", serif;
  vertical-align: middle; // Align text with formulas
}
.tex2jax_hit {
  font-size: 18px;
  font-family: "SimHei", sans-serif;
  font-weight: 700;
  margin-right: 4px;
  color: #000;
  vertical-align: middle; // Align label with text
}
.formula_tex {
  display: inline-block;
  padding: 0 4px;
  margin: 0;
  vertical-align: middle; // Align center for multiline formulas (cases, matrices)
  line-height: normal;
}
</style>
